import React, { useEffect, useState } from "react"
import { Tab, Tabs } from "react-bootstrap"
import MissingData from "./MissingData"
import axios from "axios"
import ProjectsData from "./ProjectsData/ProjectsData"
import { convertPermission } from "permissionUtils"

export default function Drive({ projectData, ProjectID, setAuth }) {
  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )

  // const [data, setData] = useState([])
  const [missingData, setMissingData] = useState([])
  const [ticketData, setTicketData] = useState([])

  const [missingDataLoading, setMissingDataLoading] = useState(true)
  const [ticketsLoading, setTicketsLoading] = useState(true)

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID: ProjectID,
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/Drive_info.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }
        setMissingData(res.data.MissingData)
        setMissingDataLoading(false)

        setTicketData(res.data.TicketData)
        setTicketsLoading(false)
      })
      .catch(err => console.log("error------>", err))
  }, [])

  return (
    <div>
      <Tabs className="mb-3" justify fill>
        <Tab eventKey="reports" title="TicketData">
          <MissingData
            Data={ticketData}
            title={"Ticket"}
            loading={ticketsLoading}
          />
        </Tab>
        <Tab eventKey="tickets" title="MissingData">
          <MissingData
            Data={missingData}
            title={"Missing"}
            loading={missingDataLoading}
          />
        </Tab>

        <Tab eventKey="projects-data" title="Projects Data">
          <ProjectsData
            projectData={projectData}
            ProjectID={ProjectID}
            setAuth={setAuth}
            userPermissions={userPermissions}
          />
        </Tab>
      </Tabs>
    </div>
  )
}
